<template>
  <validation-observer ref="step2">
    <b-form>
      <b-row>
        <b-col cols="4">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="facebookChecked" disabled></b-form-checkbox>
                <h4 class="mb-0">Facebook</h4>
              </div>
              <div>
                <feather-icon icon="FacebookIcon" class="text-info" size="25" />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="instagramChecked" disabled></b-form-checkbox>
                <h4 class="mb-0">Instagram</h4>
              </div>
              <div>
                <feather-icon
                  icon="InstagramIcon"
                  class="text-danger"
                  size="25"
                />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="4">
          <b-card class="shadow-none border">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="linkedinChecked" disabled></b-form-checkbox>
                <h4 class="mb-0">LinkedIn</h4>
              </div>
              <div>
                <feather-icon
                  icon="LinkedinIcon"
                  class="text-info text-darken-2"
                  size="25"
                />
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="12">
          <h4>Post Details</h4>
          <b-form-checkbox
            v-if="facebookChecked && instagramChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook, Instagram, and LinkedIn
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="facebookChecked && instagramChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook and Instagram
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="facebookChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Facebook and LinkedIn
          </b-form-checkbox>
          <b-form-checkbox
            v-else-if="instagramChecked && linkedinChecked"
            name="check-button"
            class="mb-2"
            switch
            inline
            v-model="isSwitchChecked"
          >
            Customise post for Instagram and LinkedIn
          </b-form-checkbox>
          <b-tabs v-if="isSwitchChecked">
            <b-tab v-if="facebookChecked" title="Facebook">
              <b-form-group
                label="Facebook Description"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Facebook Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignIdss.description"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
            <b-tab v-if="instagramChecked" title="Instagram">
              <b-form-group
                label="Instagram Description"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="Instagram Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignIdss.description"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
            <b-tab v-if="linkedinChecked" title="LinkedIn">
              <b-form-group
                label="LinkedIn Description"
                label-for="description"
              >
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="LinkedIn Post"
                  vid="Description"
                >
                  <quill-editor
                    v-model="campaignIdss.description"
                    :state="errors.length > 0 ? false : null"
                    
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-tab>
          </b-tabs>
          <b-form-group v-else label="Description" label-for="description">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="email content"
              vid="Description"
            >
              <quill-editor
                v-model="campaignIdss.description"
                :state="errors.length > 0 ? false : null"
                disabled
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-form-radio v-model="SelectedRadio" name="radio1" value="D" @change="emitAction('draft')" disabled>
              Save as Draft
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="A" @change="emitAction('sendNow')" disabled>
              Send Now
            </b-form-radio>
            <b-form-radio v-model="SelectedRadio" name="radio1" value="B" @change="emitAction('schedule')" disabled>
              Schedule Sending
            </b-form-radio>
          </div>
        </b-col>

        <!-- date and time -->
        <b-col md="12" class="mt-2" v-if="SelectedRadio === 'B'">
          <b-row>
            <b-col md="4">
              <!-- facebook scheduling -->
              <b-form-group v-if="facebookChecked" class="mb-1">
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="date and time"
                  vid="dateNtim"
                >
                  <div class="d-flex align-items-end mb-1">
                    <feather-icon
                      icon="FacebookIcon"
                      class="text-info"
                      size="18"
                    />
                    <h5 class="ml-1 mb-0">Facebook</h5>
                  </div>
                  <b-form-datepicker
                    v-model="campaignIdss.scheduledPublishedDate"
                    id="form-control"
                    placeholder="Choose a date"
                    local="en"
                    :initial-date="new Date()"
                    :min="today"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <!-- instagram scheduling -->
              <!-- <b-form-group v-if="instagramChecked" class="mb-1">
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="date and time"
                  vid="dateNtim"
                >
                  <div class="d-flex align-items-end mb-1">
                    <feather-icon
                      icon="InstagramIcon"
                      class="text-danger"
                      size="18"
                    />
                    <h5 class="ml-1 mb-0">Instagram</h5>
                  </div>
                  <b-form-datepicker
                    v-model="campaignIdss.scheduledPublishedDate"
                    id="form-control"
                    placeholder="Choose a date"
                    local="en"
                    :initial-date="new Date()"
                    :min="today"
                    
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->
            </b-col>

            <b-col md="4">
              <!-- linkedin scheduling -->
              <!-- <b-form-group v-if="linkedinChecked">
                <validation-provider
                  rules="required"
                  #default="{ errors }"
                  name="date and time"
                  vid="dateNtim"
                >
                  <div class="d-flex align-items-end mb-1">
                    <feather-icon
                      icon="LinkedinIcon"
                      class="text-info text-darken-2"
                      size="18"
                    />
                    <h5 class="ml-1 mb-0">Linkedin</h5>
                  </div>
                  <b-form-datepicker
                    v-model="campaignIdss.scheduledPublishedDate"
                    id="form-control"
                    placeholder="Choose a date"
                    local="en"
                    :initial-date="new Date()"
                    :min="today" disabled
                    
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->
            </b-col>
          </b-row>
        </b-col>

        
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BCardText,
  BFormCheckbox,
  BCard,
  BTabs,
  BTab,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";
import { FormWizard, TabContent } from "vue-form-wizard";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import CampaignDetails from "./CampaignDetails.vue";
export default {
  name: "AddCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCardText,
    BFormCheckbox,
    BCard,
    BTabs,
    BTab,
    FormWizard,
    TabContent,
    CampaignDetails,
  },
  data() {
    return {
      id: this.$route.params.id,
      mainLoading: false,
      imageFiles: [],
      imagePreviews: [],
      emailtemplatelist: [],
      selectedProvider: null,
      selectedTemplateId: null,
      selectedTemplate: [],
      Selected: "A",
      smtp: [],
      Selected1: "c",
      SelectedRadio: null, // Default to "Save as Draft"
      dateNtim: null,
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      content: "",
      name: "",
      budget: null,
      plannedBudget: null,
      startDate: null,
      endDate: null,
      subject: "",
      file: null,
      selectedSegments: [],
      segmentOptions: [],
      required,
      linkedinChecked: false,
      facebookChecked: false,
      instagramChecked: false,
      isSwitchChecked: false,
      facebookContent: "",
      instagramContent: "",
      linkedinContent: "",
    };
  },

  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      appid: "appid",
      campaignIdss: "campaignId",
      posts: "posts",
      loadingMarketing: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction",
      "postMarketingCampaignAction",
      "getMarketingCampaignByIDAction",
      "putMarketingCampaignAction", "getCampaignDraftListAction"
    ]),
    emitAction(action) {
      this.$emit('action-selected', action); // Emit the selected action back to the parent
    },
    showImagePreview(event) {
      this.imageFiles = [...event.target.files];
      this.imagePreviews = [];

      for (let file of this.imageFiles) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
        };

        reader.readAsDataURL(file);
      }
    },
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select a date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async formSubmitted(status) {
      // Validate the form if status is not 'DRAFT'
      if (status !== "DRAFT") {
        const isValid = await this.$refs.formAddCampaign.validate();
        if (!isValid) {
          // Handle invalid form
          return;
        }
      }

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Campaign is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        campaignId: this.id,
        name: this.campaignId.name,
        startDate: this.campaignId.startDate,
        endDate: this.campaignId.endDate,
        description: this.campaignId.description,
        subject: this.campaignId.name,
        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            content: this.campaignId.description,
            scheduledPublishedDate:
              status === "SCHEDULED"
                ? this.campaignId.scheduledPublishedDate
                : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
          },
        ],
        smtpSettingId: this.selectedProvider,
      };

      await this.putMarketingCampaignAction(payload)
        .then((response) => {
          loader.close();
          if (status === "SCHEDULED") {
            this.success(
              `Marketing Campaign successfully scheduled for ${this.dateNtim}!`
            );
          } else {
            this.success("Marketing Campaign Updated!");
          }

          this.$router.push({ name: "marketing-campaign-list" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });
    },

    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    success(message) {
      this.$swal({
        title: "Marketing Campaign Added!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    saveScheduled() {
      if (this.dateNtim === null) {
        this.errordateNtime();
        return;
      }

      if (this.SelectedRadio === "B" && this.dateNtim) {
        this.formSubmitted("SCHEDULED");
      } else {
        this.formSubmitted("DRAFT");
      }
    },

    sendNow() {
      if (this.SelectedRadio === "A") {
        this.formSubmitted("COMPLETED");
      }
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    this.facebookToken = this.$route.query.access_token;
    this.mainLoading = true;
    try {
      await this.getMarketingCampaignByIDAction(this.id);

      await this.getCampaignDraftListAction();

      const filteredDrafts = this.posts.filter(draft => draft.campaignId === this.id);
      // console.log("draftsssssssssssssssssssssssssss", filteredDrafts);

      // console.log("postssssssssss", filteredDrafts.length);

      if(this.campaignIdss.status === "SCHEDULED"){
        console.log("postssssssssss", this.campaignIdss);

        if (this.campaignIdss.campaignDrafts[0].platform === "Facebook"){
          this.facebookChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "Instagram"){
          this.instagramChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "LinkedIn"){
          this.linkedinChecked = true;
        }
        
        this.SelectedRadio = "B";
        console.log("datesssssssssssss", this.campaignIdss.scheduledPublishedDate);
        this.campaignIdss.scheduledPublishedDate = this.campaignIdss.campaignDrafts[0].scheduledPublishedDate;
      }
       if(this.campaignIdss.status === "COMPLETED"){
        
        if (this.campaignIdss.campaignDrafts[0].platform === "Facebook"){
          this.facebookChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "Instagram"){
          this.instagramChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "LinkedIn"){
          this.linkedinChecked = true;
        }
        
        this.SelectedRadio = "A";
      }
       if(this.campaignIdss.status === "DRAFT"){
        
        if (this.campaignIdss.campaignDrafts[0].platform === "Facebook"){
          this.facebookChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "Instagram"){
          this.instagramChecked = true;
        }
        else if (this.campaignIdss.campaignDrafts[0].platform === "LinkedIn"){
          this.linkedinChecked = true;
        }
        
        this.SelectedRadio = "D";
      }

      if (this.filteredDrafts.length > 0) {
        this.campaignIdss.description = filteredDrafts[0].content; 
        console.log("content", this.campaignIdss[0]);
    } 
    
    //if(this.campaignId.)


      await this.getEmailTemplateListAction().then(() => {
        this.emailtemplatelist = this.emailtemplate.map((template) => ({
          value: template.templateId,
          text: `${template.name}`,
        }));
      });

      await this.getSMPT();

      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
    }
  },
  watch: {
    startDate(newDate) {
      if (
        newDate &&
        this.endDate &&
        new Date(this.endDate) < new Date(newDate)
      ) {
        this.endDate = null; // Clear endDate if it is earlier than startDate
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
</style>
